import styled, { css } from "styled-components";
import { parseSizeToken, useDesignTokens } from "@boi/react-design-tokens";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 100%;
  overflow: hidden;
`;

type IconWrapperProps = {
  $isLoading?: boolean;
};

export const IconWrapper = styled.span<IconWrapperProps>`
  ${({ $isLoading }) => {
    const { tokens } = useDesignTokens();
    const { button } = tokens;

    const width = parseSizeToken(button.topLayer.icon.width);
    const height = parseSizeToken(button.topLayer.icon.width);

    return css`
      display: flex;
      flex-shrink: 0;
      visibility: ${$isLoading ? "hidden" : "visible"};

      svg {
        width: ${width};
        height: ${height};
      }
    `;
  }}
`;

type TypographyWrapperProps = {
  $isLoading?: boolean;
};

export const TypographyWrapper = styled.div<TypographyWrapperProps>`
  ${({ $isLoading }) => {
    return css`
      visibility: ${$isLoading ? "hidden" : "visible"};
      overflow: hidden;
    `;
  }}
`;

export const SpinnerWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
`;
